export default __webpack_public_path__ + "static/media/Boys-Hostel.9434dea2.jpg";